import { FC } from "react";
import {
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  Stack,
  Typography,
} from "@mui/material";

import { AddressType } from "../../../../store";
import { PopupViewer } from "../../../molecules";
import { AddressDialog } from "../../../organisms";
import { useCreateAddress } from "../../../hooks";
import { AddressSection } from "./AddressSection";

interface Props {
  addressData: AddressType[];
  shippingAddress: AddressType | undefined;
  setShippingAddress: (a: AddressType) => void;
  billingAddress: AddressType | undefined;
  setBillingAddress: (a: AddressType) => void;
  shippingAndBillingSame: boolean;
  setShippingAndBillingSame: (a: boolean) => void;
}

export const Address: FC<Props> = ({
  addressData,
  shippingAddress,
  setShippingAddress,
  billingAddress,
  setBillingAddress,
  shippingAndBillingSame,
  setShippingAndBillingSame,
}) => {
  const { showAddressDialog, setShowAddressDialog, onSubmitAddress } =
    useCreateAddress();

  return (
    <div>
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <Stack direction="row" gap={1} alignItems="center">
          <Typography
            variant="subtitle2"
            textTransform="uppercase"
            fontWeight={700}>
            Address
          </Typography>
        </Stack>
        <Button size="small" onClick={() => setShowAddressDialog(true)}>
          Add Address
        </Button>
      </Stack>
      {shippingAddress && (
        <Box sx={{ mt: 2 }}>
          <AddressSection
            address={shippingAddress}
            allAddress={addressData}
            setAddress={setShippingAddress}
            title="Shipping Address"
          />
        </Box>
      )}
      {billingAddress && !shippingAndBillingSame && (
        <Box sx={{ mt: 2 }}>
          <AddressSection
            address={billingAddress}
            allAddress={addressData}
            setAddress={setBillingAddress}
            title="Billing Address"
          />
        </Box>
      )}
      <FormControlLabel
        control={
          <Checkbox
            size="small"
            checked={shippingAndBillingSame}
            onChange={e => setShippingAndBillingSame(e.target.checked)}
          />
        }
        label="Billing address same as shipping address"
        disableTypography
        sx={{ fontSize: "14px", mt: 1 }}
      />
      <PopupViewer open={showAddressDialog} setOpen={setShowAddressDialog}>
        <AddressDialog
          open={showAddressDialog}
          onClose={() => setShowAddressDialog(false)}
          onSubmit={onSubmitAddress}
          currency="INR"
        />
      </PopupViewer>
    </div>
  );
};
